export default function getDaysInbetween(date1, date2) {
  var dateDifferenceTime = new Date(date1).getTime() - new Date(date2).getTime();
  var dateDifferenceInDays = Math.ceil(dateDifferenceTime / (1000 * 3600 * 24));
  return dateDifferenceInDays;
}